import type { AdminStudioListItem } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveAdminStudios = createApiThunk<AdminStudioListItem[], void>(
  "admin/studios/retrieve",
  async (_, { extra: { adminRepository } }) => {
    return adminRepository!.listStudios();
  },
);
